import React from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import Button from '../../components/Button';
import Input from '../../components/Input';
import require from '../../lib/WithValidation/rules/required';
import PropTypes from 'prop-types';
import translate from '../../lib/utils/translate';

var ChangeUsername = function ChangeUsername(_ref) {
  var errors = _ref.errors,
      intl = _ref.intl,
      onSubmit = _ref.onSubmit,
      _onBlur = _ref.onBlur,
      isLoading = _ref.isLoading;

  return React.createElement(
    'form',
    { className: 'form', onSubmit: onSubmit },
    React.createElement(Input, {
      title: translate({
        id: 'title.username',
        defaultMessage: 'Username'
      }, intl),
      placeholder: translate({ id: 'label.username' }, intl),
      type: 'text',
      name: 'Username',
      onBlur: function onBlur(value) {
        return _onBlur('Username', value);
      },
      error: errors.Username && translate({ id: errors.Username }, intl)
    }),
    React.createElement(
      Button,
      {
        isLoading: isLoading,
        className: 'button primary wide',
        type: 'submit' },
      translate({ id: 'action.button.submit_change_username' }, intl)
    )
  );
};

ChangeUsername.propTypes = {
  /** Is the form loading or not */
  isLoading: PropTypes.bool,
  /** The submission function firing when submitting the form */
  onSubmit: PropTypes.func,
  /** When user moves focus from input field */
  onBlur: PropTypes.func
};

ChangeUsername.defaultProps = {
  isLoading: false,
  onSubmit: Function,
  onBlur: Function
};
var rules = {
  Username: [[require, 'error.empty.username']]
};

export default compose(WithValidation(rules), injectIntl)(ChangeUsername);